/**
 * Typed cache keys for the tickets feature.
 *
 * Per ADR-0012: query keys are typed constants, never inline string arrays.
 */
export const ticketsKeys = {
	all: ['tickets'] as const,
	adminList: (params: { status: string; page: number }) => [...ticketsKeys.all, 'admin-list', params] as const,
	syncJob: (jobId: string | null) => [...ticketsKeys.all, 'sync-job', jobId] as const,
}
